var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizDragDropPair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35B35D",
    stroke: "#205731",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M14.674 1.338h7.855v7.855h-7.855z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.874 5.755-.42 1.271h-.539l1.373-4.042h.629l1.38 4.042h-.558l-.432-1.271h-1.433zm1.325-.407-.396-1.163c-.09-.264-.15-.504-.21-.738h-.012c-.061.24-.126.486-.204.731l-.396 1.169h1.218z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M14.674 14.807h7.855v7.855h-7.855z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.431 16.508c.228-.048.587-.084.953-.084.521 0 .857.09 1.109.294.21.156.336.396.336.713 0 .39-.258.732-.684.888v.012c.384.096.833.414.833 1.014 0 .348-.138.612-.342.81-.281.258-.737.378-1.396.378-.36 0-.636-.024-.81-.048v-3.977zm.521 1.655h.474c.552 0 .876-.288.876-.678 0-.474-.36-.66-.888-.66-.24 0-.378.018-.462.036v1.302zm0 1.937c.102.018.252.024.438.024.54 0 1.038-.198 1.038-.786 0-.552-.475-.78-1.044-.78h-.432V20.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#35B35D",
    stroke: "#205731",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M10.604 4.79h7.855v7.855h-7.855z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m13.805 9.207-.42 1.271h-.539l1.373-4.042h.629l1.38 4.042h-.558l-.432-1.271h-1.433zm1.325-.408-.396-1.163c-.09-.264-.15-.504-.21-.738h-.012c-.061.24-.126.486-.204.731l-.396 1.169h1.218z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M1.602 1.338h7.855v7.855H1.602z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.359 3.039c.228-.048.587-.084.953-.084.521 0 .857.09 1.109.294.21.156.336.396.336.713 0 .39-.258.732-.684.888v.012c.384.096.833.414.833 1.014 0 .348-.138.612-.342.81-.28.257-.736.377-1.395.377-.36 0-.636-.024-.81-.048V3.039zm.522 1.655h.474c.552 0 .876-.288.876-.678 0-.474-.36-.66-.888-.66-.24 0-.378.018-.462.036v1.302zm0 1.937c.102.018.252.024.438.024.54 0 1.038-.198 1.038-.786 0-.552-.475-.78-1.044-.78h-.432v1.542z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M20.979 14.097H19.33l1.145 2.73-.915.385-1.146-2.73-1.238 1.225V10.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizDragDropPair);
export default __webpack_public_path__ + "static/media/quiz_dragDropPair.99f1dd12155bbc25ede49c0f536d6710.svg";
export { ForwardRef as ReactComponent };